import { toSpecialFixed } from '../misc/utils';
export default function getCurrentGains(_a) {
    var tokenPnLData = _a.tokenPnLData;
    var cGains = toSpecialFixed((tokenPnLData === null || tokenPnLData === void 0 ? void 0 : tokenPnLData.unrealisedPNL) + (tokenPnLData === null || tokenPnLData === void 0 ? void 0 : tokenPnLData.realisedPNL), 2).value;
    return {
        number: Number(cGains),
        string: Number(cGains) < 0 ? cGains.replace('-', '-$') : '$' + cGains,
    };
}
